 
// import "./TermsConditions.css"; 
import React, { Component } from "react";
class TermsConditions  extends Component   {    render() {
  return (
    <div className="container votePage">
      <div className="row container-fluid m-0 p-0">
        <div className="col-lg-12 col-md-12 top-info">
          <h2 className="terms-main-title italics">Nepal Idol Season 6 Paid Voting Terms</h2>
          <p className="terms-sub-title italics">Thanks for choosing Nepal Idol Season 6 Voting!</p>
          <p className="terms-sub-title italics">
            Nepal Idol Season 6, franchise program of Nepal Idol is a singing reality show aired in AP1 HD.
          </p>
          <p className="terms-sub-title italics">
            In using this service you are deemed to have read and agreed to the following terms and conditions:
          </p>
          <p>
            These Terms of Service (“Terms”) cover your use and access to our services, Client software and
            websites/mobile App (“Services”). The following terminology applies to these Terms and Conditions,
            Privacy Statement and Disclaimer Notice and any or all Agreements: “Client”, “You” and “Your”
            refers to you, the person accessing this website and using its service and accepting the Company’s
            terms and conditions. “The Company”, “Ourselves”, “We” and “Us”, refers to Music Nepal. “Party”,
            “Parties”, or “Us”, refers to both the Client and ourselves, or either the Client or ourselves. All
            terms refer to the offer, acceptance and consideration of payment necessary to undertake the process
            of our assistance to the Client in the most appropriate manner...
          </p>

          <h2 className="italics">Your Responsibilities</h2>
          <p>
            You’re responsible for the content contained in Voting Form. Nepal Idol Season 6 specifically prohibits the posting
            of any content that violates or infringes the copyright rights and/or other intellectual property rights...
          </p>

          <h2 className="italics">Voting Plans and Payment Terms</h2>
          <p>
            By purchasing a Voting Plan, you acknowledge that your purchase has a prepayment feature of service...
          </p>
          <ul>
            <li className="terms-list">1 Votes Plan (NPR 10)</li>
            <li className="terms-list">50 Votes Plan (NPR 50)</li>
            <li className="terms-list">10 Votes Plan (NPR 100)</li>
            <li className="terms-list">20 Votes Plan (NPR 200)</li>
            <li className="terms-list">50 Votes Plan (NPR 500)</li>
            <li className="terms-list">100 Votes Plan (NPR 1,000)</li>
            <li className="terms-list">500 Votes Plan (NPR 5,000)</li>
            <li className="terms-list">1000 Votes Plan (NPR 10,000)</li>
            <li className="terms-list">5000 Votes Plan (NPR 50,000)</li>
          </ul>
          <p>
            Payment terms on Paid Voting Plans are non-refundable...
          </p>

          <h2 className="italics">Confidentiality</h2>
          <p>
            As a general rule, the Company does not disclose any personally identifiable information...
          </p>
          <p>
            <strong>
              We will not sell, share, or rent your personal information to any third party...
            </strong>
          </p>

          <h2 className="italics">Disclaimer</h2>
          <h4>Exclusions and Limitations</h4>
          <p>
            The information on this web site is provided on an “as is” basis. To the fullest extent permitted by law...
          </p>
          <ul>
            <li className="terms-list">
              Excludes all representations and warranties relating to this website and its contents...
            </li>
            <li className="terms-list">
              Excludes all liability for damages arising out of or in connection with your use of this website...
            </li>
          </ul>

          <p>This Company does not however exclude liability for death or personal injury caused by its negligence...</p>

          <h2 className="italics">Availability</h2>
          <p>
            Unless otherwise stated, the services featured on this website are available worldwide...
          </p>

          <h2 className="italics">Waiver</h2>
          <p>
            Failure of either Party to insist upon strict performance of any provision of this or any Agreement...
          </p>

          <h2 className="italics">Privacy Statement</h2>
          <p>
            We are committed to protecting your privacy...
          </p>

          <h2 className="italics">Copyright Notice</h2>
          <p>
            Copyright and other relevant intellectual property rights exists on all text relating to the Company’s services...
          </p>

          <h2 className="italics">Log Files</h2>
          <p>
            We use IP addresses to analyze trends, administer the site, track user’s movement...
          </p>

          <h2 className="italics">Notification of Changes</h2>
          <p>
            The Company reserves the right to change these conditions from time to time as it sees fit...
          </p>

          <h2 className="italics">Force Majeure</h2>
          <p>
            Neither party shall be liable to the other for any failure to perform any obligation under any Agreement...
          </p>

          <h2 className="italics">General</h2>
          <p>
            By accessing this website/mobile App [and using our services/buying our products] you consent to
            these terms and conditions and to the exclusive jurisdiction of the Nepal courts...
          </p>

          <p>
            <strong>
              These terms and conditions form part of the Agreement between the Client and ourselves...
            </strong>
          </p>
        </div>
      </div>
    </div>
  )};
};

export default TermsConditions;
